import { useTranslation } from "react-i18next";
import { useNavigate, useParams, Params } from "react-router-dom";

import { styled } from "@mui/system";
import Typography from "@mui/material/Typography";

import { motion } from "framer-motion";

import Code from "../../assets/icons/Code.svg";
import Manual from "../../assets/icons/Manual.svg";

import Title from "../../components/Title";
import BackButton from "../../components/BackButton";

import useIdleEffect from "../../lib/hooks/useIdleEffect";
import OfflineModal from "../../components/Offline/OfflineModal";
import Curve from "../../components/Animations/PageTransitions/Curve";
import Bump from "../../components/Animations/Bump";

const MUIOptionButtonGroup = styled("div")({
  maxWidth: "90.4rem",
  width: "96%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "4.8rem 0 2.4rem",

  "@media screen and (orientation: landscape)": {
    maxWidth: "180.8rem",
    flexDirection: "row",
    padding: "0",

    "> div": {
      width: "50%",
    },
  },
});

export const MUIOptionButton = styled(motion.button)(({ theme }) => ({
  position: "relative",
  width: "90%",
  height: "16rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "2.25rem 0 3.5rem",
  borderRadius: "1rem",
  border: `0.2rem solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.primary.main,

  ":hover": {
    backgroundColor: theme.palette.primary.dark,
    border: `0.2rem solid ${theme.palette.primary.dark}`,
  },

  svg: {
    position: "absolute",
    left: "4rem",
    fill: theme.palette.background.default,
  },

  h3: {
    color: theme.palette.background.default,
    margin: "0 12rem",
  },

  "@media screen and (orientation: landscape)": {
    height: "14rem",
    margin: "0 1rem 6.4rem 6rem",
  },
}));

interface IQueryParams extends Params {
  action: "checkin" | "checkout";
}

const CheckOptions = () => {
  const navigate = useNavigate();

  const { action } = useParams() as IQueryParams;

  const { t } = useTranslation();

  useIdleEffect(() => {
    navigate("/", { replace: true });
  }, 60000);

  return (
    <Curve>
      <div className="d-flex align-items-center flex-column">
        <BackButton to="/" />
        <Title className="page-title home">
          <Typography variant="h1">
            {t(`check:option.${action}.title`)}
          </Typography>
        </Title>
        <MUIOptionButtonGroup>
          <Bump>
            <MUIOptionButton
              onClick={() => {
                return navigate(`/access/${action}`, { replace: true });
              }}
            >
              <Code width="8rem" />
              <Typography variant="h3">
                {t(`check:option.${action}.code`)}
              </Typography>
            </MUIOptionButton>
          </Bump>
          <Bump>
            <MUIOptionButton
              onClick={() => {
                return navigate(`/access/${action}/manual`, { replace: true });
              }}
            >
              <Manual width="8rem" />
              <Typography variant="h3">
                {t(`check:option.${action}.manual`)}
              </Typography>
            </MUIOptionButton>
          </Bump>
        </MUIOptionButtonGroup>
      </div>
      <OfflineModal />
    </Curve>
  );
};

export default CheckOptions;
